import React, { PropsWithChildren } from "react"

import { Color } from "../../../constants/V2/color"
import Grid from "../../elements/V2/Grid"
import LayoutHeader, { LayoutHeaderProps } from "../LayoutComponents/Header"
import LayoutSection, { CTAProps } from "../LayoutComponents/LayoutSection"

import { getAccentColor } from "@utils/V2/color"

type Props = PropsWithChildren<
  CTAProps & {
    id?: string
    primaryBackgroundColor: Color
    secondaryBackgroundColor?: Color
    tertiaryBackgroundColor?: Color
    gradientDirection?: "to-b" | "to-br"
    className?: string
    secondaryCtaText?: string
    secondaryCtaLink?: string | YocoCom.YocoLink
    rounded?: boolean
    heading?: LayoutHeaderProps
  }
>

const GridSection = ({
  id,
  primaryBackgroundColor,
  secondaryBackgroundColor,
  tertiaryBackgroundColor,
  gradientDirection,
  className,
  ctaType,
  ctaColor,
  ctaText,
  ctaLink,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  secondaryCtaText,
  secondaryCtaLink,
  rounded = true,
  heading,
  children,
  ...props
}: Props) => {
  return (
    <LayoutSection
      id={id}
      ctaType={ctaType}
      ctaText={ctaText}
      ctaLink={ctaLink}
      ctaColor={ctaColor}
      trackingEvent={trackingEvent}
      trackingEventKey={trackingEventKey}
      trackingEventValue={trackingEventValue}
      primaryBackgroundColor={primaryBackgroundColor}
      secondaryBackgroundColor={secondaryBackgroundColor}
      tertiaryBackgroundColor={tertiaryBackgroundColor}
      gradientDirection={gradientDirection}
      secondaryCtaText={secondaryCtaText}
      secondaryCtaLink={secondaryCtaLink}
      rounded={rounded}
      {...props}
    >
      {(heading?.superscriptText ||
        heading?.headingText ||
        heading?.headingBodyText ||
        heading?.callout) && (
        <LayoutHeader
          {...heading}
          superscriptColor={
            heading.superscriptColor || getAccentColor(primaryBackgroundColor)
          }
          headingTextColor={
            heading.headingTextColor || getAccentColor(primaryBackgroundColor)
          }
          headingBodyColor={
            heading.headingBodyColor || getAccentColor(primaryBackgroundColor)
          }
          calloutTextColor={
            heading.calloutTextColor || getAccentColor(primaryBackgroundColor)
          }
        />
      )}

      {React.Children.count(children) > 0 && (
        <Grid className={className}>{children}</Grid>
      )}
    </LayoutSection>
  )
}

export default GridSection
